document.addEventListener('DOMContentLoaded', function () {
	"use strict";

	console.log("ZWSSGR Email Sync: DOM loaded");

	document.addEventListener("click", function (zwssgrEv) {
		const zwssgrSyncButton = zwssgrEv.target.closest(".zwssgr-sync-email");

		if (!zwssgrSyncButton) {
			return;
		}

		console.log("ZWSSGR Email Sync: Sync button clicked:", zwssgrSyncButton);

		zwssgrEv.preventDefault();

		if (zwssgrSyncButton.classList.contains("disabled")) {
			console.log("ZWSSGR Email Sync: Button already disabled");
			return;
		}

		zwssgrSyncReviewsByEmail(zwssgrSyncButton);
	});

	function zwssgrToggleAllSyncButtons(zwssgrDisabled) {
		const zwssgrButtons = document.querySelectorAll(".zwssgr-sync-email");

		console.log("ZWSSGR Email Sync: Toggle all buttons:", zwssgrDisabled);

		zwssgrButtons.forEach(function (zwssgrButton) {
			if (zwssgrDisabled) {
				zwssgrButton.classList.add("disabled");
				zwssgrButton.setAttribute("disabled", "disabled");
			} else {
				zwssgrButton.classList.remove("disabled");
				zwssgrButton.removeAttribute("disabled");
				zwssgrButton.innerHTML = "Sync Now";
			}
		});
	}

	function zwssgrSyncReviewsByEmail(zwssgrSyncButton) {
		console.log("ZWSSGR Email Sync: zwssgrSyncReviewsByEmail called");

		const zwssgrGmbEmail = zwssgrSyncButton.getAttribute("zwssgr-gmb-email");

		console.log("ZWSSGR Email Sync: GMB email:", zwssgrGmbEmail);
		console.log("ZWSSGR Email Sync: Localized object:", window.zwssgr_admin);

		if (!zwssgrGmbEmail) {
			console.error("ZWSSGR Email Sync: GMB email missing");
			return;
		}

		if (
			typeof window.zwssgr_admin === "undefined" ||
			!window.zwssgr_admin.ajax_url
		) {
			console.log("ZWSSGR Admin Full Object:", window.zwssgr_admin);
			console.log("ZWSSGR Admin ajax_url:", window.zwssgr_admin?.ajax_url);
			console.log("ZWSSGR Admin nonce:", window.zwssgr_admin?.nonce);
			return;
		}

		zwssgrToggleAllSyncButtons(true);

		zwssgrSyncButton.innerHTML = '<span class="spinner is-active"></span> Creating Queue...';

		const zwssgrFormData = new FormData();

		zwssgrFormData.append("action", "zwssgr_email_sync_reviews");
		zwssgrFormData.append("zwssgr_gmb_email", zwssgrGmbEmail);

		fetch(window.zwssgr_admin.ajax_url, {
			method: "POST",
			body: zwssgrFormData,
			credentials: "same-origin"
		})
			.then(function (zwssgrResponse) {
				console.log("ZWSSGR Email Sync: Queue create response:", zwssgrResponse);
				return zwssgrResponse.json();
			})
			.then(function (zwssgrResult) {
				console.log("ZWSSGR Email Sync: Queue create result:", zwssgrResult);

				if (!zwssgrResult.success) {
					throw new Error(
						zwssgrResult.data && zwssgrResult.data.message
							? zwssgrResult.data.message
							: "Sync queue creation failed."
					);
				}

				if (
					!zwssgrResult.data ||
					!zwssgrResult.data.zwssgr_queue_key
				) {
					throw new Error("Queue key missing in response.");
				}

				zwssgrSyncButton.innerHTML = '<span class="spinner is-active"></span> Syncing...';

				return zwssgrProcessEmailSyncQueue(
					zwssgrResult.data.zwssgr_queue_key,
					zwssgrSyncButton
				);
			})
			.catch(function (zwssgrError) {
				console.error("ZWSSGR Email Sync: Error:", zwssgrError);

				alert(
					zwssgrError.message
						? zwssgrError.message
						: "Something went wrong while syncing reviews."
				);
			})
			.finally(function () {
				console.log("ZWSSGR Email Sync: Completed, enabling all buttons");
				zwssgrToggleAllSyncButtons(false); 
			});
	}

	function zwssgrProcessEmailSyncQueue(zwssgrQueueKey, zwssgrSyncButton) {
		const zwssgrFormData = new FormData();

		zwssgrFormData.append("action", "zwssgr_process_email_sync_queue");
		zwssgrFormData.append("zwssgr_queue_key", zwssgrQueueKey);

		return fetch(window.zwssgr_admin.ajax_url, {
			method: "POST",
			body: zwssgrFormData,
			credentials: "same-origin"
		})
			.then(function (zwssgrResponse) {
				return zwssgrResponse.json();
			})
			.then(function (zwssgrResult) {

				if (!zwssgrResult.success) {
					throw new Error(
						zwssgrResult.data && zwssgrResult.data.message
							? zwssgrResult.data.message
							: "Queue processing failed."
					);
				}

				if (
					zwssgrResult.data &&
					zwssgrResult.data.processed_widget 
				) {
				}

				if (
					zwssgrResult.data &&
					zwssgrResult.data.completed
				) {
					
					zwssgrSyncButton.innerHTML = "Synced";

					// Reload page
					window.location.reload();

					return zwssgrResult;
				}

				zwssgrSyncButton.innerHTML = '<span class="spinner is-active"></span> Syncing Next...';

				return zwssgrProcessEmailSyncQueue(zwssgrQueueKey, zwssgrSyncButton);
			});
	}
});